angular
  .module('filters.timeAgo', [])
  .filter('timeAgo', function() {
    return function(date) {
      moment.locale('pl');
      return date ? moment(date).from() : '';
    };
  });



// WEBPACK FOOTER //
// ./client/src/common/filters/timeAgo.js